import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import cx from "classnames";

import styles from "./Checkbox.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode,
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(({
  checked,
  label,
  id,
  required,
  ...rest
}, ref) => {
  return (
    <div className={styles.Container}>
      <input
        ref={ref}
        id={id}
        className={cx(styles.Checkbox, {
          [styles.WithLabel]: label !== undefined,
        })}
        type="checkbox"
        checked={checked}
        onClick={(e) => e.stopPropagation()}
        required={required}
        {...rest}
      />
      {label && (
        <label
          htmlFor={id}
          className={styles.Label}
        >
          {label}
          {required && <span className={styles.Required}>*</span>}
        </label>
      )}
    </div>
  );
});

Checkbox.displayName = "Checkbox";

